/**
 * fusionLib form validator methods.
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND WITHOUT ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
 *
 * @package fusionLib
 * @copyright Copyright (c) 2007 - 2023 fusionLib. All rights reserved.
 * @link http://fusionlib.com
 */

(function() {

	/**
	 * Get the value of an element.
	 *
	 * @param fusionLib elem The element.
	 * @returns The elements value.
	 */
	function getVal(elem) {
		if(elem[0].type == 'checkbox')
			return elem.is(':checked');
		else
			return elem.val();
	}

	/**
	 * Count the number of checked elements in a selection.
	 *
	 * @param fusionLib elem The selected elements to count.
	 * @return int The number of checked elements.
	 */
	function countChecked(elem) {
		var count = 0;
		elem.each(function() { if($(this).is(':checked')) count++; });
		return count;
	}

	/**
	 * Function used to update the validation message.
	 *
	 * @param map options The options for validating the form.
	 * string elementName The name of the element to update the validation status message for.
	 * string state The new state of the element, ok, failed, ajax or hide.
	 * string msg The message e.g. A valid email address is required.
	 */
	function updateMessage(options, name, state, msg) {
		if(state == 'ok' && options.elemValidText && options.elemValidText[name])
			msg = options.elemValidText[name];
		else if(state == 'ok' && options.showOnlyErrors) {
			msg = '&nbsp;';
			state = 'hide';
		}

		name = name.replace('[]', '');
		$('#' + name).removeClass('validationError');

		var label;
		if((label = $('#' + name).attr('title')) == null) {
			label = $('#' + name + '-label').html();
			label = !label ? '' : label.replace(/^<[^>]+>/, '').replace(/<.*$/, '');
		}

		if(state == 'ok' || state == 'hide') {
			$('#' + name + '-label').removeClass('validationError');
			$('#' + name).closest('.uploadButton').removeClass('validationError');
		}
		else {
			$('#' + name + '-label').addClass('validationError');
			$('#' + name).closest('.uploadButton').addClass('validationError');
		}

		$('#' + name + '-validation').removeClass('ok').removeClass('failed').removeClass('ajax').removeClass('hide').addClass(state).find('strong').html(msg.replace('{label}', label));
		if(state != 'ok' && state != 'hide')
			$('#' + name).addClass('validationError');
	}

	/**
	 * Functions to validate an element.
	 *
	 * All validators take elem which is a fusionLib object of the element(s) to test and options which is a map of options:
	 *	msg - If given is the error message to show, {label} is replaced with the elements label and {current} is replaced with the current value
	 *	val - Is a value to test against, {value} in options.msg is replace with this number
	 *
	 * The return value is true if the validator passes or the error message to show if it fails.
	 */
	var validators = {
		/**
		 * Test that a required element is given.
		 */
		required: function(elem, options) {
			if(!getVal(elem))
				return options.msg ? options.msg : "{label} is required.";
			else
				return true;
		},

		/**
		 * Test the minimum length of the element is val or more characters long.
		 */
		minLength: function(elem, options) {
			var l = elem.val().length;
			if(l && l < options.val)
				return (options.msg ? options.msg : "{label} contains {current} characters but must contain at least {value} characters.").replace('{value}', options.val).replace('{current}', l);
			else
				return true;
		},

		/**
		 * Test the maximum length of the element is val or less characters long.
		 */
		maxLength: function(elem, options) {
			var l = elem.val().length;
			if(l && l > options.val)
				return (options.msg ? options.msg : "{label} contains {current} characters but is only allowed to contain {value} characters.").replace('{value}', options.val).replace('{current}', l);
			else
				return true;
		},

		/**
		 * Test if the element has a valid email address.
		 */
		email: function(elem, options) {
			if(elem.val().length && !/^([a-z0-9](?:[a-z0-9&'+=_\.-]+)?)@([a-z0-9_-]+)(\.[a-z0-9_-]+)*(\.[a-z]{2,})+$/i.test(elem.val()))
				return options.msg ? options.msg : "{label} must be a valid working email address.";
			else
				return true;
		},

		/**
		 * Test if the element has a valid email address, supports multiple addressees.
		 */
		multiemail: function(elem, options) {
			if(elem.val().length && !/^([a-z0-9](?:[a-z0-9&'+=_\.-]+)?)@([a-z0-9_-]+)(\.[a-z0-9_-]+)*(\.[a-z]{2,})+(\s*,\s*([a-z0-9](?:[a-z0-9&'+=_\.-]+)?)@([a-z0-9_-]+)(\.[a-z0-9_-]+)*(\.[a-z]{2,})+)*$/i.test(elem.val()))
				return options.msg ? options.msg : "{label} must contain valid working email addresses, multiple email addresses can be given if separated by a comma.";
			else
				return true;
		},

		/**
		 * Test if the element has a valid URI
		 */
		uri: function(elem, options) {
			if(elem.val().length && !/^((srv\+)?(http|https):\/\/)?([\w-]+:[\w-]+@)?[\w-]+(?:\.[\w-]+)*(?::\d+)?(?:\/[\w ~\\\(\)%\=\.,\+-]*)*(?:\?[\w ~\\\(\)%\=\.,\+-]+=[\w ~\\\(\)%\=\.,\+-]*(?:&[\w ~\\\(\)%\=\.,\+-]+=[\w ~\\\(\)%\=\.,\+-]*)*)?(#[\w ~\\\(\)%\=\.,\/\+-]*)?$/i.test(elem.val()))
				return options.msg ? options.msg : "{label} must be a valid address of a web page.";
			else
				return true;
		},

		/**
		 * Test if the value of the element is the same as another element.
		 */
		sameAs: function(elem, options) {
			if(elem.val() != $('#' + options.val).val())
				return (options.msg ? options.msg : "{label} must match {labelOther}.").replace('{labelOther}', $('#' + options.val + '-label').html());
			else
				return true;
		},

		/**
		 * Test if the element is an integer.
		 */
		integer: function(elem, options) {
			if(!elem.val().length || /^[+-]?\d+$/.test(elem.val()))
				return true;
			else
				return options.msg ? options.msg : "{label} must be an integer.";
		},

		/**
		 * Test if the element is a number.
		 */
		number: function(elem, options) {
			if(!elem.val().length || /^[+-]?(\d+)?(\.\d+)?$/.test(elem.val()))
				return true;
			else
				return options.msg ? options.msg : "{label} must be a number.";
		},

		/**
		 * Test if the value of an element is >= than a min value.
		 */
		min: function(elem, options) {
			if(elem.val().length && elem.val() < options.val) {
				elem.val(options.val);
				return (options.msg ? options.msg : "{label} must be at least {value}.").replace('{value}', options.val);
			}
			else
				return true;
		},

		/**
		 * Test if the value of an element is <= than a max value.
		 */
		max: function(elem, options) {
			if(elem.val().length && elem.val() > options.val) {
				elem.val(options.val);
				return (options.msg ? options.msg : "{label} must be {value} or less.").replace('{value}', options.val);
			}
			else
				return true;
		},

		/**
		 * Test if the value of an element is >= than a min value as set in the min attribute.
		 */
		attribmin: function(elem, options) {
			var m = elem.attr('min');
			if(m != null && elem.val().length && elem.val() < parseInt(m)) {
				elem.val(m);
				return (options.msg ? options.msg : "{label} must be at least {value}.").replace('{value}', m);
			}
			else
				return true;
		},

		/**
		 * Test if the value of an element is <= than a max value as set in the max attribute.
		 */
		attribmax: function(elem, options) {
			var m = elem.attr('max');
			if(m != null && elem.val().length && elem.val() > parseInt(m)) {
				elem.val(m);
				return (options.msg ? options.msg : "{label} must be {value} or less.").replace('{value}', m);
			}
			else
				return true;
		},

		/**
		 * Test against a regular expression.
		 */
		regex: function(elem, options) {
			if(elem.val().length && !options.val.test(elem.val()))
				return options.msg ? options.msg : "{label} is not valid.";
			else
				return true;
		},

		/**
		 * Test if equals a value.
		 */
		equals: function(elem, options) {
			if(elem.val().length && options.val != elem.val())
				return (options.msg ? options.msg : "{label} must be {value}.").replace('{value}', options.val);
			else
				return true;
		},

		/**
		 * Test if not equal to a value.
		 */
		notEquals: function(elem, options) {
			if(elem.val().length && options.val == elem.val())
				return (options.msg ? options.msg : "{label} must not be {value}.").replace('{value}', options.val);
			else
				return true;
		},

		/**
		 * Test if a minimum number of elements are selected in a checklist.
		 */
		minChecklist: function(elem, options) {
			var count = countChecked(elem);
			if(count < options.val)
				return (options.msg ? options.msg : "You must select at least {value} items for {label}, currently only {current} items are selected.").replace('{value}', options.val).replace('{current}', count);
			else
				return true;
		},

		/**
		 * Test if less than a maximum number of elements are selected in a checklist.
		 */
		maxChecklist: function(elem, options) {
			var count = countChecked(elem);
			if(count > options.val)
				return (options.msg ? options.msg : "You can only select a maximum of {value} items for {label}, currently you have selected {current} items.").replace('{value}', options.val).replace('{current}', count);
			else
				return true;
		},

		/**
		 * Test by using custom JavaScript.
		 */
		custom: function(elem, options) {
			return options.fn(elem) ? true : options.msg;
		}
	};

	var extend = window.jQuery || window.fusionLib;
	extend.fn.extend({
		/**
		 * Attach form validation to the selected item.
		 *
		 * @param map options The options for validating the form.
		 * @return fustionLib This object.
		 */
		attachValidation: function(options) {
			if(!this[0])
				return this;

			var theForm = this[0];

			options.ajaxWaitingText = options.ajaxWaitingText || 'Please wait...';
			options.ajaxFailedText = options.ajaxFailedText || 'Unexpected failure.';
			options.showOnlyErrors = options.showOnlyErrors === undefined ? true : options.showOnlyErrors;

			/**
			 * Validate a field against the rule set.
			 */
			function validateElem(count, isSubmit) {
				var result = true,
					name = this[0].name ? this[0].name : this[0].id,
					elem = $(this[0].name ? '[name="' + name + '"]' : '#' + name);

				if(!elem.attr('data-validation-skip')) {
					// Run all defined rules for the element
					for (var rule in options.rules[name]) {
						if(!elem.attr('data-validation-skip-' + rule)) {
							if (rule == 'ajax') {

								if(options.rules[name]['ajax']['skipOnSubmit'])
									continue;

								// Set wait message
								updateMessage(options, name, 'ajax', options.ajaxWaitingText);

								// Stop ok message showing while ajax running
								if (isSubmit !== true)
									result = false;

								// Do the AJAX call
								$.ajax(theForm.action, {
									type: theForm.method,
									timeout: 3000,
									async: isSubmit !== true,
									success: function (r) {

										// If callback function available
										r.updateMsg = true;
										if (options.rules[name]['ajax']['callback']) {
											r.updateMsg = false;
											updateMessage(options, name, 'ok', r.msg);
											if (!eval(options.rules[name]['ajax']['callback'] + '(r)'))
												result = false;
										}

										if (r.updateMsg) {
											if (!r.valid) {
												updateMessage(options, name, 'failed', r.msg);
												result = false;
											}
											else if (isSubmit !== true)
												updateMessage(options, name, 'ok', r.msg);
										}
									},
									error: function () {
										updateMessage(options, name, 'failed', options.ajaxFailedText);
										result = false;
									},
									data: {
										form: theForm.id,
										elem: name,
										value: getVal(this),
										_validating: true
									}
								});
								break;
							}
							// If validator available run it, stop checking if not valid
							else if (validators[rule] && true !== (result = validators[rule](elem, options.rules[name][rule]))) {
								updateMessage(options, name, 'failed', result);
								result = false;
								break;
							}
						}
					}
				}

				// If valid then output message and move to next element
				if(result === true)
					updateMessage(options, name, 'ok', options.validText);

				// Return the result for onsubmit processing
				if(isSubmit)
					return result;
				// else check for items matching this
				else {
					// If another field must match this then revalidate as well
					for(var name2 in options.rules) {
						for(var rule in options.rules[name2]) {
							if(rule == 'sameAs' && options.rules[name2][rule].val == name) {
								elem = $('[name="' + name2 + '"]');
								if(elem[0].flValueLast !== undefined)
									validateElem.call(elem, 0);
								break;
							}
						}
					}
				}
			}

			// Build an anonymous function to validate the form
			var validate = function(evt) {
				if(!this.name && !this.id)
					return;

				// Select the element
				var elem = $(this.name ? '[name="' + this.name + '"]' : '#' + this.id),
					name = this.name ? this.name : this.id;

				if(options.rules[name] && (elem.length > 1 || getVal(elem).length > 0 || elem[0].flValueLast != undefined) && (evt.type == 'change' || elem[0].flValueLast != getVal(elem))) {
					elem[0].flValueLast = getVal(elem);
					updateMessage(options, name, 'hide', '');
					elem.first().timerStop('fusionLibValidation', validateElem)
								.timerOnce(1000, 'fusionLibValidation', validateElem);
				}
			};

			/**
			 * Handle validation on submit.
			 */
			var onSubmit = function(evt) {
				if($(this).attr('data-validation-skip') !== 'true') {
					var firstElement;

					// Let updates happen before validation starts
					$(this).trigger('validationOnBeforeSubmit');
					$(window).trigger('_cfFormValidationBeforeSubmit');

					// For all rules run the element validation tracking the 1st failed element
					for(var name in options.rules) {
						var elem = $('[name="' + name + '"]');
						if(!elem.length)
							elem = $('#' + name);
						if(!validateElem.call(elem, 0, true) && firstElement == undefined)
							firstElement = elem;
					}

					// If errors focus the 1st element
					if(firstElement !== undefined) {
						firstElement.focus();
						evt.preventDefault();
						evt.stopPropagation();
						$(theForm).trigger('formValidationFailed');
						$(window).trigger('_cfFormValidationFailed');
						return false;
					}
					// Else if has onSubmit function
					else if(options.onSubmit && options.onSubmit() === false) {
						evt.preventDefault();
						evt.stopPropagation();
						$(theForm).trigger('formValidationFailed');
						$(window).trigger('_cfFormValidationFailed');
						return false;
					}
					// Else if has an onSubmit event handler
					else {
						var data = {
							stopSubmit: false, // true to stop and fail
							cancelSubmit: false // true to stop
						};

						$(this).trigger('validationOnSubmit', [data]);
						if(data.stopSubmit || data.cancelSubmit) {
							evt.preventDefault();
							evt.stopPropagation();
							if(data.stopSubmit) {
								$(theForm).trigger('formValidationFailed');
								$(window).trigger('_cfFormValidationFailed');
							}
							return false;
						}
					}

					$(this).trigger('validationDone');
					$(window).trigger('_cfFormValidationDone');
				}
			};

			// Attach the validate function to events
			this.on('submit', onSubmit).on('validation', onSubmit);
			this.find('input').each(function() {
				if(this.type == 'checkbox' || this.type == 'radio' || this.type == 'file')
					$(this).on('change', validate);
				else
					$(this).on('blur', validate).on('keyup', validate);
			});
			this.find('select').on('blur', validate).on('change', validate);
			this.find('textarea').on('blur', validate).on('keyup', validate);

			return this;
		}
	});
})();